export default __webpack_public_path__ + "static/tablets-9d69ff3992ed5d752903c3f8363d2b34.mp4";